import * as HTML_RENDITION from '../utils/general/general';
import { RSCH_HTML_TRACKING_CONFIG } from '../readership/trackingConfig';

export const cv_openCampaignPage = (url: string, campaignsSource: any) => {
    let openLinkPrefix = 'cvopenhtml:';
    if (!HTML_RENDITION.isCVLink(url)){
        openLinkPrefix = 'cvopenexternallink:';
    }
    const campaignName = campaignsSource.campaigns[0]['campaignID'];
    const isCVCampaign = campaignsSource.campaigns[0]['cvcampaign'];
    RSCH_HTML_TRACKING_CONFIG.trackCampaignClick(campaignName, isCVCampaign);

    window.location.href = openLinkPrefix + url;
};
